import { ClassNames } from '@emotion/react'
import { cloneElement, ReactElement, ReactNode } from 'react'
import { SListContainer, SListText } from './StepList.styled'

function StepListItem(props: { children?: ReactNode; icon?: ReactElement; className?: string }) {
  return (
    <SListText className={props.className}>
      <ClassNames>
        {({ css }) =>
          props.icon &&
          cloneElement(props.icon, {
            className: css`
              margin-right: 12px;
              flex-shrink: 0;
              margin-top: calc((1.6em - 12px) / 2);
            `,
          })
        }
      </ClassNames>
      {props.children}
    </SListText>
  )
}

export function StepList(props: {
  className?: string
  items?: ReactNode[] | undefined
  icon: ReactElement
}) {
  return (
    <SListContainer className={props.className}>
      {props.items?.map?.((perk, index) => (
        <li key={index}>
          <StepListItem icon={props.icon}>{perk}</StepListItem>
        </li>
      )) ?? []}
    </SListContainer>
  )
}
